import { useQuery } from '@tanstack/react-query';
import { payApiClient } from '../services/payApiClient';
import { API_ENDPOINTS } from '@/config/apiEndpoints';

const PAY_QUERY_OPTS = { retry: 1, retryDelay: 2000 };

export const useKPIs = () => {
  return useQuery({
    queryKey: ['pay', 'kpis'],
    queryFn: () => payApiClient.get(API_ENDPOINTS.PAY_DASHBOARD_KPIS),
    staleTime: 2 * 60 * 1000,
    ...PAY_QUERY_OPTS,
  });
};

export const usePayoutsList = (filters = {}) => {
  return useQuery({
    queryKey: ['pay', 'payouts', 'list', filters],
    queryFn: () => payApiClient.get(API_ENDPOINTS.PAY_PAYOUTS_LIST, {}, filters),
    staleTime: 2 * 60 * 1000,
    ...PAY_QUERY_OPTS,
  });
};

export const useReconciliationStatus = () => {
  return useQuery({
    queryKey: ['pay', 'reconciliation', 'status'],
    queryFn: () => payApiClient.get(API_ENDPOINTS.PAY_RECONCILIATION_STATUS),
    staleTime: 2 * 60 * 1000,
    ...PAY_QUERY_OPTS,
  });
};

export const useDailyReport = (reportDate) => {
  return useQuery({
    queryKey: ['pay', 'reports', 'daily', reportDate],
    queryFn: () => payApiClient.get(API_ENDPOINTS.PAY_REPORTS_DAILY, {}, reportDate ? { report_date: reportDate } : {}),
    staleTime: 5 * 60 * 1000,
    ...PAY_QUERY_OPTS,
  });
};

export const useMonthlyReport = (year, month) => {
  return useQuery({
    queryKey: ['pay', 'reports', 'monthly', year, month],
    queryFn: () => payApiClient.get(API_ENDPOINTS.PAY_REPORTS_MONTHLY, {}, { year, month }),
    enabled: !!year && !!month,
    staleTime: 5 * 60 * 1000,
    ...PAY_QUERY_OPTS,
  });
};

export const useCustomReport = (dateFrom, dateTo) => {
  return useQuery({
    queryKey: ['pay', 'reports', 'custom', dateFrom, dateTo],
    queryFn: () => payApiClient.get(API_ENDPOINTS.PAY_REPORTS_CUSTOM, {}, { date_from: dateFrom, date_to: dateTo }),
    enabled: !!dateFrom && !!dateTo,
    staleTime: 5 * 60 * 1000,
    ...PAY_QUERY_OPTS,
  });
};
